import Image from "next/image";
import { useTranslations } from "next-intl";

const DEFAULT_FONT_SIZE = "28px";

const MARKETPLACES = ["exchange"] as const;
const SOCIALS = ["twitter", "medium", "discord"] as const;

type Marketplaces = (typeof MARKETPLACES)[number];
type Socials = (typeof SOCIALS)[number];

type Networks = Marketplaces | Socials;

function getNetworkCategory(network: Networks): string {
  if (MARKETPLACES.includes(network as Marketplaces)) {
    return "Marketplaces";
  } else if (SOCIALS.includes(network as Socials)) {
    return "Socials";
  } else {
    return "Unknown";
  }
}

interface NetworkIconProps {
  fontSize?: string;
  network: Networks;
  showLabel?: boolean;
  className?: string;
}

export const NetworkIcon = ({
  network,
  fontSize = DEFAULT_FONT_SIZE,
  showLabel,
  className,
}: NetworkIconProps): JSX.Element => {
  const t = useTranslations(getNetworkCategory(network));

  return (
    <div
      className={`flex flex-row items-center justify-between w-full ${className}`}
    >
      {showLabel && <span>{t(network)}</span>}
      <Image
        src={`/network_icons/${network}.png`}
        width={parseInt(fontSize)}
        height={parseInt(fontSize)}
        alt={t(network)}
      />
    </div>
  );
};
